import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, Typography, Box, Skeleton, Alert, Button, Stack } from '@mui/material';
import { useChart } from '../../chart';
import Iconify from '../../iconify/Iconify';

export default function ToPayBarChart({ data, loading, error, onRetry }) {
  const categories = (data || []).map((item) => item.employeeName || 'NA');
  const series = [
    {
      name: 'Pending',
      data: (data || []).map((item) => Number(item.pending || 0)),
    },
  ];
  const chartOptions = useChart({
    chart: { stacked: false, toolbar: { show: false } },
    plotOptions: { bar: { horizontal: true, borderRadius: 6, barHeight: '58%' } },
    xaxis: {
      categories,
      labels: {
        formatter: (value) => `₹${Number(value || 0).toLocaleString()}`,
      },
    },
    colors: ['#ff8f00'],
    tooltip: {
      y: {
        formatter: (value) => `₹${Number(value || 0).toLocaleString()}`,
      },
    },
  });

  return (
    <Card
      sx={{
        p: 2.25,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 8px 22px rgba(16, 24, 40, 0.05)',
        height: 360,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <Iconify icon="mdi:cash-clock" width={18} />
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Employee Pending ToPay
        </Typography>
      </Stack>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1, fontSize: { xs: '0.72rem', md: '0.75rem' } }}>
        Highest outstanding amounts by employee
      </Typography>

      {error ? (
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={onRetry}>
              Retry
            </Button>
          }
        >
          Failed to load to-pay summary.
        </Alert>
      ) : loading ? (
        <Skeleton variant="rectangular" height={280} sx={{ borderRadius: 2 }} />
      ) : (
        <Box sx={{ width: '100%', height: 280 }} dir="ltr">
          <ReactApexChart type="bar" height={280} series={series} options={chartOptions} />
        </Box>
      )}
    </Card>
  );
}
